<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="请输入产品名称" />
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="3" >开启</Option>
                                        <Option :value="2" >禁用</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="CreateData"><Icon type="md-add" /> 创建产品</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="b_id" ref="selection" stripe :loading="$store.state.loading" :columns="columns" @on-selection-change="TableCheckAll" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" status="processing" text="审核" />
                                    <Badge v-else-if="row.status === 2" status="error" text="禁用" />
                                    <Badge v-else-if="row.status === 3" status="success" text="开启" />
                                    <Badge v-else status="warning" text="其他" />
                                </template>
                                <template #action="{ row, index }">
                                    <a  class="text-font-sm text-primary" @click="EditData(row.b_id)">编辑</a>
                                    <Divider type="vertical"/>
                                    <a  class="text-font-sm text-999" @click="DelData(row.b_id , index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page">
                                <div class="em-page-btn">
                                    <span class="text-999">选中 <em class="text-danger">{{selectCount}}</em> 条记录</span>
                                    <Divider type="vertical" />
                                    <span class="text-999 mr10">批量</span>
                                    <ButtonGroup size="default">
                                        <Button @click="AllDelData()" >删除</Button>
                                    </ButtonGroup>
                                </div>
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="ChangePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="SaveData"></add-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {getCompanyBusinessList, deleteCompanyBusiness, deleteAllCompanyBusiness} from '@/apis/company'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "./Create";
export default {
    name: "CompanyBusiness",
    components: {
        Headers, Side, AddModal
    },
    data () {
        return {
            search: {
                name: '',
                status: '',
            },
            page : 1,
            pageSize : 10,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    type: 'selection',
                    width: 55,
                    align: 'center',
                    fixed : 'left'
                },
                {
                    title: 'ID',
                    key: 'b_id',
                    width:100
                },
                {
                    title: '名称',
                    key: 'name'
                },
                {
                    title: '排序',
                    key: 'sort',
                    width:240
                },
                {
                    title: '状态',
                    key: 'status',
                    slot : 'status',
                    width:240
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width:200
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    align: 'center',
                    width : 110,
                    fixed : 'right'
                }
            ],
            is_create : false,

        }
    },
    created(){
        this.GetList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {

        /**
         功能：搜索
         time: 2025-15-02 16:15:50
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.GetList();
        },
        /**
         功能：刷新
         time: 2025-17-02 16:17:18
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                status : '',
                name : ''
            };
            that.GetList();
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        GetList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getCompanyBusinessList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        ChangePage (e) {
            let that = this;
            that.page = e;
            that.GetList();
        },

        /**
         功能：创建
         time: 2025-26-02 09:26:21
         **/
        CreateData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑
         time: 2025-26-02 09:26:29
         **/
        EditData(b_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(b_id);
            })
        },
        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        SaveData(){
            let that = this;
            that.GetList();
        },
        /**
         功能：
         time: 2025-37-03 10:37:14
         **/
        TableCheckAll(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            that.selectCount = data.length;
        },
        /**
         功能：删除
         time: 2025-01-02 12:01:16
         **/
        DelData(b_id){
            let that = this;
            if(!b_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteCompanyBusiness(b_id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.GetList();
                    })
                },
                onCancel: () => {}
            });
        },
        AllDelData(){
            let that = this;
            const data = that.$refs.selection.getSelection();
            if(data.length <= 0){
                that.$Message.error({ background: true, content:'至少选择一条记录'});
                return false;
            }
            let bIds = [];
            for(var i  = 0; i < data.length; i++ ){
                bIds.push(data[i].b_id);
            }
            if(bIds.length > 0){
                this.$Modal.confirm({
                    title: '批量删除记录',
                    content: '此操作将批量删除记录不可恢复, 是否继续?',
                    onOk: () => {
                        deleteAllCompanyBusiness(bIds).then( e =>{
                            that.$Message.success({ background: true,duration:3, content:e.msg});
                            that.GetList();
                        })
                    },
                    onCancel: () => {}
                });
            }
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
